import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-audit-recent',
  templateUrl: './audit-recent.component.html',
  styles: []
})
export class AuditRecentComponent extends ExcTranslation implements OnInit {

  @Input() Audits: any[] = [];
  @Input() RatingMode = 'NUMERIC';
  @Input() MdtID: number = null;
  constructor() {
    super();
  }
  changeMode() {
    if (this.RatingMode === 'TRAFFIC') {
      this.RatingMode = 'STARS';
    } else if (this.RatingMode === 'STARS') {
      this.RatingMode = 'NUMERIC';
    } else {
      this.RatingMode = 'TRAFFIC';
    }
  }
  getTooltip(idx, a) {
    if (this.RatingMode === 'TRAFFIC') {
      if (a.AuditRating <= 2 && idx === 3) {
        return this.getGlobal('ResultNegative');
      } else if (a.AuditRating >= 4 && idx === 1) {
        return this.getGlobal('ResultPositive');
      } else if (a.AuditRating < 4 && a.AuditRating > 2 && idx === 2){
        return this.getGlobal('ResultNeutral');
      } else {
        return null;
      }
    }
    return null;
  }
  getAvatarClass(a) {
    if (a.AuditType === 16) {
      if (a.AuditIsPicked) {
        return 'fa-mobile th-warning';
      } else {
        return 'fa-mobile th-secondary';
      }
    } else {
      if (a.AuditIsPicked) {
        return 'fa-user-secret th-warning';
      } else {
        return 'fa-user-secret th-secondary';
      }
    }
  }
  getTrafficStyleGreen(a) {
    if (a.AuditRating < 4) {
      return {
        backgroundColor: 'transparent',
     //   border: '3px #5cb85c solid',
        border: '3px rgba(190,190,190,0.7) solid',
        width: 'calc(1.6rem - 6px)',
        height: 'calc(1.6rem - 6px)',
        opacity: '0.5'
      };
    }
    return  {
      border: 'none',
      boxShadow: '0 0 8px 7px rgba(92, 184, 92,0.7)'
    };
  }
  getTrafficStyleYellow(a) {
    if (a.AuditRating < 2 || a.AuditRating >= 4) {
      return {
        backgroundColor: 'transparent',
        // border: '3px #FAA933 solid',
        border: '3px rgba(190,190,190,0.7) solid',
        width: 'calc(1.6rem - 6px)',
        height: 'calc(1.6rem - 6px)',
        opacity: '0.5'
      };
    }
    return  {
      border: 'none',
      boxShadow: '0 0 8px 7px rgba(250,169,51,0.7)'
    };
  }
  getTrafficStyleRed(a) {
    if (a.AuditRating >= 2) {
      return {
        backgroundColor: 'transparent',
        // border: '3px #d9534f solid',
        border: '3px rgba(190,190,190,0.7) solid',
        width: 'calc(1.6rem - 6px)',
        height: 'calc(1.6rem - 6px)',
        opacity: '0.5',
      };
    }
    return  {
      border: 'none',
      boxShadow: '0 0 8px 7px rgba(217,83,79,0.7)'
    };
  }

  ngOnInit() {
  }

}
